module.exports = __webpack_public_path__ + "static/media/service1_card.252dfa9b.png";